import styled from "styled-components";

import { COLORS } from "../../../shared";

export const MixtureListProgressStyled = styled.div`
  height: 30px;
  width: 100%;
  background: ${COLORS.GRAY};
  border: 1px solid ${COLORS.GRAY_TWO};
  margin-bottom: 20px;
  border-radius: 2px;
  font-size: 14px;
  border-radius: 3px;
  overflow: hidden;

  .mixture-progress {
    &__current {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      background: ${COLORS.GREEN};
      max-width: 100%;
      color: ${COLORS.WHITE};
      &.completed {
        background-color: ${COLORS.GREEN};
      }
      &.not-completed {
        background-color: ${COLORS.YELLOW};
      }
      &.over-completed {
        background-color: red;
      }
    }
  }
`;
